import { Component, Input, OnInit } from '@angular/core';
import { Currency } from '@freelancer/datastore/collections';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { TextAlign, TextSize } from '@freelancer/ui/text';
import { PaymentShareSpendingLimitDurationApi } from 'api-typings/users/users';

@Component({
  selector: 'app-payment-share-member-modal-member-table',
  template: `
    <fl-heading
      i18n="Team Payment Member Modal Header"
      [headingType]="HeadingType.H5"
      [size]="TextSize.XSMALL"
    >
      Your Spend Limit
    </fl-heading>

    <fl-table [dataSource]="dataSource" [edgeToEdge]="true">
      <fl-table-col
        [textAlign]="TextAlign.LEFT"
        i18n-title="payment sharing member's spend limit column header"
        title="Max Spend Limit"
      >
        <ng-template #cell let-member>
          <ng-container *ngIf="isSpendingLimitActive">
            {{ spendingLimitAmount | flCurrency: currency?.code }}
          </ng-container>
          <ng-container
            *ngIf="!isSpendingLimitActive"
            i18n="No spending limit for the team member"
          >
            No Limit
          </ng-container>
        </ng-template>
      </fl-table-col>
      <fl-table-col
        [textAlign]="TextAlign.LEFT"
        i18n-title="Payment sharing member's time period column header"
        title="Per (Time Period)"
      >
        <ng-template #cell let-member [ngSwitch]="spendingLimitDuration">
          <ng-container
            *ngSwitchCase="PaymentShareSpendingLimitDurationApi.NO_TIME_LIMIT"
            i18n="No spending limit for the team member"
          >
            No Limit
          </ng-container>
          <ng-container
            *ngSwitchCase="PaymentShareSpendingLimitDurationApi.PER_MONTH"
            i18n="Payment sharing member's time period is set to per month"
          >
            Month
          </ng-container>
          <ng-container
            *ngSwitchDefault
            i18n="The payment sharing member's time period is not available"
          >
            N/A
          </ng-container>
        </ng-template>
      </fl-table-col>
      <fl-table-col
        [textAlign]="TextAlign.RIGHT"
        i18n-title="Payment sharing member's spent in this period column header"
        title="Spent This Period"
      >
        <ng-template #cell let-member>
          {{ member.spentInThisPeriod }}
        </ng-template>
      </fl-table-col>
      <fl-table-col
        [textAlign]="TextAlign.RIGHT"
        i18n-title="Payment sharing member's balance left column header"
        title="Balance Left This Period"
      >
        <ng-template #cell let-member>
          <ng-container *ngIf="isSpendingLimitActive">
            {{ member.balanceLeftThisPeriod }}
          </ng-container>
          <ng-container
            *ngIf="!isSpendingLimitActive"
            i18n="Spending limit is not activated, the balance left is N/A"
          >
            N/A
          </ng-container>
        </ng-template>
      </fl-table-col>
    </fl-table>
  `,
})
export class PaymentShareMemberModalMemberTableComponent implements OnInit {
  Margin = Margin;
  HeadingType = HeadingType;
  TextSize = TextSize;
  TextAlign = TextAlign;
  PaymentShareSpendingLimitDurationApi = PaymentShareSpendingLimitDurationApi;

  @Input() spendingLimitDuration: PaymentShareSpendingLimitDurationApi;
  @Input() spendingLimitAmount: number;
  @Input() isSpendingLimitActive: boolean;
  @Input() currentSpentAmount: number;
  @Input() currency?: Currency;

  dataSource: ReadonlyArray<{
    balanceLeftThisPeriod: string;
    spentInThisPeriod: string;
  }>;

  ngOnInit() {
    this.dataSource = [
      {
        spentInThisPeriod: this.getSpentInThisPeriod(),
        balanceLeftThisPeriod: this.getBalanceLeft(),
      },
    ];
  }

  private getBalanceLeft(): string {
    // TODO implement the logic after the backend is able to get the spentAmount (T221542)
    // return `${this.currency ? this.currency.sign : ''}${this
    //   .spendingLimitAmount - this.currentSpentAmount}`;
    return 'TBD';
  }

  private getSpentInThisPeriod(): string {
    // TODO implement the logic after the backend is able to get the spentAmount (T221542)
    // return `${this.currency ? this.currency.sign : ''}${
    //   this.currentSpentAmount
    // }`;
    return 'TBD';
  }
}
